import { useState, useEffect } from "react";
import { BAND_CONFIG } from "@/pages/hippo/constants";

export function AnimatedGauge({ value, band, onAnimationComplete, size = "default" }) {
  const [animatedValue, setAnimatedValue] = useState(0);
  const config = BAND_CONFIG[band] || BAND_CONFIG["Medium"];
  
  useEffect(() => {
    const duration = 800;
    const startTime = Date.now();
    
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setAnimatedValue(Math.round(value * eased));
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        onAnimationComplete?.();
      }
    };
    
    requestAnimationFrame(animate);
  }, [value, onAnimationComplete]);
  
  const isSmall = size === "small";
  const radius = isSmall ? 50 : 70;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (animatedValue / 100) * circumference;
  const containerSize = isSmall ? "w-32 h-32" : "w-44 h-44";
  const viewBox = isSmall ? "0 0 120 120" : "0 0 160 160";
  const center = isSmall ? 60 : 80;
  const strokeWidth = isSmall ? 8 : 10;
  const scoreSize = isSmall ? "text-3xl" : "text-4xl";
  const bandSize = isSmall ? "text-xs" : "text-sm";
  
  return (
    <div className={`relative ${containerSize} mx-auto`}>
      <div 
        className={`absolute ${isSmall ? 'inset-3' : 'inset-4'} rounded-full blur-2xl opacity-40`}
        style={{ backgroundColor: config.ring }}
      />
      <svg viewBox={viewBox} className="relative transform -rotate-90">
        <circle 
          cx={center} cy={center} r={radius} 
          fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth={strokeWidth} 
        />
        <circle
          cx={center} cy={center} r={radius}
          fill="none" stroke={config.ring} strokeWidth={strokeWidth}
          strokeLinecap="round" strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          style={{ transition: "stroke-dashoffset 0.1s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={`${scoreSize} font-bold text-white`}>{animatedValue}</span>
        <span className={`${bandSize} font-medium ${config.color}`}>{band}</span>
      </div>
    </div>
  );
}
